var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon300_20_favorite_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_1049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "favorite",
    d: "M7.93293 13.2254L7.99979 13.2859L8.06684 13.2256L8.63606 12.7141L8.6363 12.7139C9.75739 11.6997 10.6762 10.8399 11.3926 10.1347C12.1093 9.42917 12.6731 8.81226 13.0828 8.28438C13.4924 7.75666 13.7777 7.27641 13.9338 6.84423C14.089 6.41458 14.1667 5.97189 14.1667 5.51667C14.1667 4.60023 13.8487 3.82139 13.2136 3.18636C12.5786 2.55132 11.7998 2.23335 10.8833 2.23335C10.318 2.23335 9.77463 2.36801 9.2542 2.63614C8.77027 2.88545 8.35216 3.23436 8 3.68141C7.64784 3.23436 7.22973 2.88545 6.7458 2.63614C6.22537 2.36801 5.68195 2.23335 5.11667 2.23335C4.20023 2.23335 3.42139 2.55132 2.78636 3.18636C2.15132 3.82139 1.83335 4.60023 1.83335 5.51667C1.83335 5.97232 1.91395 6.42065 2.07467 6.86119C2.2362 7.30396 2.52391 7.79227 2.93354 8.32564C3.34348 8.85944 3.90588 9.47381 4.61936 10.1684L4.68912 10.0968L4.61936 10.1684C5.33219 10.8624 6.23599 11.6999 7.33049 12.6807C7.33056 12.6807 7.33064 12.6808 7.33071 12.6809L7.93293 13.2254ZM8.17948 5.02822H8.2256L8.25554 4.99314L8.83757 4.31134C9.16964 3.9527 9.49923 3.69637 9.82568 3.53806L9.78205 3.44809L9.82569 3.53806C10.1526 3.37952 10.5047 3.3 10.8833 3.3C11.5136 3.3 12.0378 3.51257 12.4626 3.93738C12.8874 4.36219 13.1 4.88636 13.1 5.51667C13.1 5.86442 13.0254 6.22047 12.8743 6.58546C12.7239 6.94865 12.4554 7.3696 12.0642 7.84896C11.673 8.32836 11.1452 8.89324 10.4801 9.5439C9.82926 10.1805 9.00275 10.9488 8.00027 11.8487C6.96457 10.9117 6.1184 10.1229 5.46148 9.48226C4.79081 8.82822 4.26616 8.26469 3.88633 7.79127C3.506 7.31724 3.24873 6.90757 3.10944 6.56139C2.96944 6.21346 2.9 5.86542 2.9 5.51667C2.9 4.88652 3.11352 4.36239 3.54041 3.93755C3.96756 3.51244 4.49083 3.3 5.11667 3.3C5.4724 3.3 5.81849 3.37816 6.15581 3.53549C6.49063 3.69167 6.82641 3.94878 7.16245 4.31136L7.74446 4.99314L7.7744 5.02822H7.82052H8.17948Z",
    fill: "#BEBEBE",
    stroke: "#BEBEBE",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOff);
export default __webpack_public_path__ + "static/media/favorite_off.0ba25f6d535213e5288e6e9a813a67d3.svg";
export { ForwardRef as ReactComponent };